var getSveaConfig_gql_default = `
  query getSveaConfig {
    storeConfig {
      svea {
        default_country
        svea_shipping_active
        default_shipping_method
      }
      shipping_origin_country_id
      shipping_origin_postcode
    }
  }
`;
export {
  getSveaConfig_gql_default as default
};
